exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".iframeStyle {\n  width: 100%;\n  height: 95%;\n  border: none;\n  background: rgba(0, 0, 0, 0);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/workflow/workflow/workflow.component.css
// module id = 2038
// module chunks = 0